import { createSelector } from 'reselect';
import { getBooleanProp, getStringProp } from '@mews/fp';
import { createScopedReducer } from '@mews-commander/utils';
import moduleSelector from '../selector';
import { RESOURCE_USE_DESELECTED, RESOURCE_USE_SELECTED, MODE_CHANGED } from './actions';
import { MODE_ACTIVE } from './constants';

export const NAME = 'reservationOverview';

const initialState = {
    selectedResourceUse: null,
    mode: MODE_ACTIVE,
};

export default createScopedReducer(initialState, {
    // @ts-expect-error $TSFixMeError: Parameter 'state' implicitly has an 'any' type.
    [RESOURCE_USE_SELECTED]: (state, selectedResourceUse) => ({
        ...state,
        selectedResourceUse,
    }),
    [RESOURCE_USE_DESELECTED]: (state: $TSFixMe) => ({
        ...state,
        selectedResourceUse: null,
    }),
    // @ts-expect-error $TSFixMeError: Parameter 'state' implicitly has an 'any' type.
    [MODE_CHANGED]: (state, mode) => ({
        ...state,
        mode,
    }),
});

export const getReservationOverview = createSelector(
    moduleSelector,
    getStringProp('scope'),
    (state, scope) => state[NAME][scope] || {}
);

export const isSidebarOpened = createSelector(
    getReservationOverview,
    getBooleanProp('isPrimary'),
    (state, isPrimary) => !!state.selectedResourceUse && isPrimary
);

export const getMode = createSelector(getReservationOverview, (reservationOverview) =>
    reservationOverview ? reservationOverview.mode : undefined
);

export const getSelectedResourceUse = createSelector(getReservationOverview, (state) => state.selectedResourceUse);
